import React from 'react'

export const Quick = () => {
  return (
    <div>Quick</div>
  )
}